// @file Composable to check for unsaved changes and prompt user to confirm before leaving the page.
import { __ } from '@@/bits/intl'
import { onBeforeUnmount, onMounted } from 'vue'

export const useCheckUnsavedChangesBeforeReload = ({ shouldAlert }: { shouldAlert: () => boolean }): void => {
  const checkUnsavedChanges = (event: BeforeUnloadEvent): string | undefined => {
    if (shouldAlert()) {
      const alertMessage = __(
        'It looks like you have unsaved changes. Are you sure you want to discard them and close this page?',
      )

      // set the alert, reference: https://stackoverflow.com/a/7317311/13700092
      // most browsers don't support custom message any more, usually a generic message will be shown

      // For the alert to show in Gecko + IE
      event.returnValue = alertMessage

      // For the alert to show in Gecko + Webkit, Safari, Chrome, ...
      return alertMessage
    }

    return undefined
  }

  onMounted(() => {
    window.addEventListener('beforeunload', checkUnsavedChanges)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', checkUnsavedChanges)
  })
}
